/**
 * Тексты карточек Services. Менять копирайт здесь, не в JSX.
 */

export const SERVICE_CHATBOTS = {
    title: "Chatbots & Messengers",
    titleSpeed: 90,
    titleDelay: 300,
    text: "We build smart bots across Telegram, Instagram, WhatsApp and Viber. Payment processing, newsletters, CRM integrations. From simple chatbots to complex automated sales systems.",
    textSpeed: 35,
    textDelay: 1600,
};

export const SERVICE_MINI_APPS = {
    title: "Mini Apps",
    titleSpeed: 90,
    titleDelay: 400,
    text: "We create mobile applications for iOS and Android. Native development and cross-platform solutions using React Native and Flutter. Full cycle from design to App Store and Google Play publication.",
    textSpeed: 38,
    textDelay: 1500,
};

export const SERVICE_AI = {
    title: "AI & Automation",
    titleSpeed: 90,
    titleDelay: 400,
    text: "We implement artificial intelligence and automation. Chatbots with AI, data processing, machine learning models. Smart solutions for business optimization.",
    textSpeed: 35,
    textDelay: 1500,
    bars: [
        { label: "NN", width: "85%" },
        { label: "DATA", width: "72%" },
        { label: "ML", width: "90%" },
    ],
};

export const SERVICE_SOFTWARE = {
    title: "Custom Software Development",
    titleSpeed: 90,
    titleDelay: 400,
    text: "We build specialized software for unique business needs. Desktop applications, command-line tools, background services, data migration scripts. From simple automation to complex enterprise solutions tailored to your workflow.",
    textSpeed: 35,
    textDelay: 2100,
};

export const SERVICE_WEBSITES = {
    title: "Web sites",
    titleSpeed: 90,
    titleDelay: 400,
    text: "We develop modern websites and web applications. Landing pages, corporate sites, e-commerce, SPA. Responsive design, performance optimization, SEO.",
    textSpeed: 35,
    textDelay: 1500,
};

export const SERVICE_UIUX = {
    title: "UI/UX Design",
    titleSpeed: 90,
    titleDelay: 700,
    text: "We create intuitive and attractive interfaces. User research, prototyping, design systems and brand identity. Focus on user experience and conversion optimization.",
    textSpeed: 35,
    textDelay: 1600,
};

export const SERVICE_DEVOPS = {
    title: "Cloud & DevOps",
    titleSpeed: 90,
    titleDelay: 400,
    text: "Cloud infrastructure and deployment automation. CI/CD pipelines, Docker containerization, server configuration. Reliable and scalable hosting for your projects.",
    textSpeed: 35,
    textDelay: 1500,
};

// config/services.js
